import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Pencil = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="pencil icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.4645 2.1212C35.4171 0.168581 38.5829 0.168585 40.5356 2.12121L45.8787 7.46435C47.8313 9.41697 47.8313 12.5828 45.8787 14.5354L15.7071 44.707C15.5708 44.8433 15.398 44.9373 15.2095 44.9777L1.20955 47.9777C0.877866 48.0488 0.532769 47.9468 0.292911 47.707C0.053053 47.4671 -0.0488592 47.122 0.0222153 46.7904L3.02222 32.7904C3.0626 32.6019 3.15661 32.4291 3.29291 32.2928L33.4645 2.1212ZM39.1213 3.53542C37.9498 2.36385 36.0503 2.36384 34.8787 3.53542L4.91594 33.4982L2.95521 42.6482L5.35166 45.0447L14.5017 43.084L44.4645 13.1212C45.6361 11.9496 45.6361 10.0501 44.4645 8.87856L39.1213 3.53542Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.7071 8.29278C35.0977 8.6833 35.0977 9.31647 34.7071 9.70699L8.70712 35.707C8.3166 36.0975 7.68344 36.0975 7.29291 35.707C6.90239 35.3165 6.90239 34.6833 7.29291 34.2928L33.2929 8.29278C33.6834 7.90225 34.3166 7.90225 34.7071 8.29278Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.2929 5.29278C30.6834 4.90225 31.3166 4.90225 31.7071 5.29278L42.7071 16.2928C43.0976 16.6833 43.0976 17.3165 42.7071 17.707C42.3166 18.0975 41.6834 18.0975 41.2929 17.707L30.2929 6.70699C29.9024 6.31647 29.9024 5.6833 30.2929 5.29278Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.29291 31.2928C4.68344 30.9022 5.3166 30.9022 5.70712 31.2928L16.7071 42.2928C17.0976 42.6833 17.0976 43.3165 16.7071 43.707C16.3166 44.0975 15.6834 44.0975 15.2929 43.707L4.29291 32.707C3.90239 32.3165 3.90239 31.6833 4.29291 31.2928Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.7071 13.2928C40.0977 13.6833 40.0977 14.3165 39.7071 14.707L13.7071 40.707C13.3166 41.0975 12.6834 41.0975 12.2929 40.707C11.9024 40.3165 11.9024 39.6833 12.2929 39.2928L38.2929 13.2928C38.6834 12.9023 39.3166 12.9023 39.7071 13.2928Z"
    />
  </svg>
)
